import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { productCatalog } from '../../data/products/shared';
const colClass: Record<number, string> = {
  2: 'lg:grid-cols-2',
  3: 'lg:grid-cols-3',
  4: 'lg:grid-cols-4'
};
export function ProductsUsed({
  keys
}: {
  keys: string[];
}) {
  const items = keys.map(k => productCatalog[k]).filter(Boolean);
  return <section className="w-full bg-canvas-sky py-20" aria-labelledby="products-used-heading" data-id="element-1532" data-mp="oscexfe1c0qh">
      <div className="mx-auto max-w-shell px-6" data-id="element-1533" data-mp="tq4hr4g7x79g">
        <h2 id="products-used-heading" className="display text-[30px] font-semibold text-ink sm:text-[40px]" data-id="element-1534" data-mp="tqw4rqvr1wo4">
          Products used
        </h2>
        <ul className={`mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 ${colClass[items.length] ?? 'lg:grid-cols-4'}`} data-id="element-1535" data-mp="12jhksz7zxp99">
          {items.map(item => {
          const Icon = item.icon;
          return <li key={item.title} data-id="element-1536" data-mp="a1vh060lzsyc">
                <SmartLink href={item.href} className="group flex h-full flex-col rounded-[14px] bg-white p-6 transition-shadow duration-150 ease-out hover:shadow-[0_12px_28px_-18px_rgba(11,11,11,0.35)]" data-id="element-1537" data-mp="a0u4dx3y2yei">
                  <span className="flex h-10 w-10 items-center justify-center rounded-[9px] border border-canvas-line text-ink transition-colors duration-150 ease-out group-hover:text-brand" data-id="element-1538" data-mp="18jqlb1x8j6eu">
                    <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} aria-hidden="true" data-id="element-1539" data-mp="ymkvry49rngq" />
                  </span>
                  <h3 className="mt-5 text-[17px] font-semibold tracking-[-0.02em] text-ink" data-id="element-1540" data-mp="ujxyvisqrcco">{item.title}</h3>
                  <p className="mt-2 text-[14.5px] leading-[1.55] text-ink-muted" data-id="element-1541" data-mp="pm67qqzx7u9j">{item.copy}</p>
                  <span className="mt-auto inline-flex items-center gap-1.5 pt-5 text-[14px] font-semibold text-brand" data-id="element-1542" data-mp="ko4drb0yiaja">
                    Explore
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1543" data-mp="2f0u81tv8llr7" />
                  </span>
                </SmartLink>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}